import styled from 'styled-components';
import theme from '../../assets/styles/theme';

export const ItemEstablishment = styled.div`
  display: flex;
  justify-content: flex-start;
  border: none;
`;

export const Info = styled.div`
  width: ${theme.spacing['spacing-13']};
`;

export const BrandWrapper = styled.div``;

export const Detail = styled.div``;

export const FirstContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SecondContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${theme.spacing['spacing-3']};
  span:first-child {
    margin-bottom: ${theme.spacing['spacing-2']};
  }
`;
